import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Emit, Prop, PropSync, Vue } from 'vue-property-decorator';
import { EntryApi, ProductApi } from "@/apis";
import { cloneDeep } from "lodash-es";
import { DATETIME_FORMAT, RESULT_CODE_CONST, ENTRY_DEADLINE_OVER_MESSAGE } from "@/constants/constants";
import { format } from "date-fns";
export var INITIAL_ENTRY = {
    id: undefined,
    corporateID: undefined,
    customerID: undefined,
    customerName: undefined,
    status: undefined,
    paymentStatus: undefined,
    paymentMethod: undefined,
    comment: undefined,
    experienceRecord: undefined,
    totalAmount: undefined,
    purchaseList: [],
    memberID: undefined,
    memberName: undefined,
    startDateTime: undefined,
    endDateTime: undefined,
    scheduleIDs: [],
    paymentList: [],
};
export var INITIAL_CUSTOMER = {
    id: undefined,
    corporateID: undefined,
    email: undefined,
    name: undefined,
    phone: undefined,
    postCode: undefined,
    address: undefined,
    customerType: undefined,
    coupons: [],
};
var EntryForm2 = /** @class */ (function (_super) {
    __extends(EntryForm2, _super);
    function EntryForm2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.schedule = null;
        _this.product = null;
        _this.subProduct = null;
        _this.comment = '';
        _this.customer = cloneDeep(INITIAL_CUSTOMER);
        return _this;
    }
    Object.defineProperty(EntryForm2.prototype, "getStartDate", {
        get: function () {
            return format(this.syncedTarget.day, DATETIME_FORMAT.YYYYMMDD_JP) + " " + this.syncedTarget.time;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntryForm2.prototype, "getPlaceName", {
        get: function () {
            if (this.schedule) {
                return this.schedule.placeName;
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EntryForm2.prototype, "validationRules", {
        get: function () {
            return {
                email: [],
                firstName: [],
                lastName: [],
                firstNameKana: [],
                lastNameKana: [],
                phone: [],
                postCode: [],
                address: [],
            };
        },
        enumerable: false,
        configurable: true
    });
    EntryForm2.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, new ProductApi().getProductPublic({
                                id: this.productId,
                                corporateId: this.corporateId
                            }).then(function (res) { return res.data; })];
                    case 1:
                        _a.product = (_b.sent()) || {};
                        if (this.syncedTarget.schedules && this.syncedTarget.schedules.length === 1) {
                            // スケジュールが1件のみの場合には確定させる
                            this.schedule = this.syncedTarget.schedules[0];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EntryForm2.prototype.selectMember = function (memberID) {
        console.log("selectMember " + memberID);
        if (this.syncedTarget) {
            var schedule = this.syncedTarget.schedules.find(function (member) { return member.memberID === memberID; });
            if (schedule) {
                this.schedule = schedule;
            }
        }
    };
    EntryForm2.prototype.selectSubProduct = function (subCode) {
        var _a, _b;
        this.subProduct = ((_b = (_a = this.product) === null || _a === void 0 ? void 0 : _a.subProducts) === null || _b === void 0 ? void 0 : _b.find(function (subProduct) { return subProduct.subCode === subCode; })) || null;
    };
    EntryForm2.prototype.validateForm = function () {
        if (!this.$refs.entryForm.validate()) {
            return;
        }
        this.save();
    };
    EntryForm2.prototype.save = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __awaiter(this, void 0, void 0, function () {
            var entry, createdEntry;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        if (!this.schedule || !this.schedule.id) {
                            return [2 /*return*/];
                        }
                        entry = cloneDeep(INITIAL_ENTRY);
                        entry.memberID = (_a = this.schedule) === null || _a === void 0 ? void 0 : _a.memberID;
                        entry.memberName = (_b = this.schedule) === null || _b === void 0 ? void 0 : _b.memberName;
                        entry.startDateTime = (_c = this.schedule) === null || _c === void 0 ? void 0 : _c.startDateTime;
                        entry.endDateTime = (_d = this.schedule) === null || _d === void 0 ? void 0 : _d.endDateTime;
                        entry.corporateID = this.corporateId;
                        entry.comment = this.comment;
                        entry.customer = this.customer;
                        entry.scheduleIDs = [this.schedule.id];
                        entry.purchaseList = [{
                                productID: (_e = this.product) === null || _e === void 0 ? void 0 : _e.id,
                                productName: (_f = this.product) === null || _f === void 0 ? void 0 : _f.name,
                                subCode: (_g = this.subProduct) === null || _g === void 0 ? void 0 : _g.subCode,
                                subProductName: (_h = this.subProduct) === null || _h === void 0 ? void 0 : _h.name,
                                price: (_j = this.product) === null || _j === void 0 ? void 0 : _j.prices,
                                quantity: 1,
                                amount: (_k = this.product) === null || _k === void 0 ? void 0 : _k.prices,
                            }],
                            entry.totalAmount = (_l = this.product) === null || _l === void 0 ? void 0 : _l.prices;
                        return [4 /*yield*/, new EntryApi().createEntry({
                                body: entry
                            }).then(function (res) { return res.data; })];
                    case 1:
                        createdEntry = _m.sent();
                        if (createdEntry && createdEntry.resultCode === RESULT_CODE_CONST.ENTRY_DEADLINE_OVER) {
                            // 予約受付期限切れ（画面を開いたまま日付をまたいだ場合など）
                            alert(ENTRY_DEADLINE_OVER_MESSAGE);
                        }
                        return [2 /*return*/, 'cal'];
                }
            });
        });
    };
    EntryForm2.prototype.cancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'cal'];
            });
        });
    };
    __decorate([
        Prop()
    ], EntryForm2.prototype, "corporateId", void 0);
    __decorate([
        Prop()
    ], EntryForm2.prototype, "productId", void 0);
    __decorate([
        PropSync('target', { type: Object })
    ], EntryForm2.prototype, "syncedTarget", void 0);
    __decorate([
        Emit('applied')
    ], EntryForm2.prototype, "save", null);
    __decorate([
        Emit('push')
    ], EntryForm2.prototype, "cancel", null);
    EntryForm2 = __decorate([
        Component({})
    ], EntryForm2);
    return EntryForm2;
}(Vue));
export default EntryForm2;
